var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArbitrum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Arbitrum_icon",
    "data-name": "Arbitrum icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 32,
    height: 32,
    rx: 12,
    transform: "translate(0 32) rotate(-90)",
    fill: "transparent"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arbitrum_symbol",
    "data-name": "Arbitrum symbol",
    transform: "translate(-36.411 -68.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbol_-_Original_7_",
    transform: "translate(43.758 74.673)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M206.953,80.7l1.427-2.421,3.846,5.99,0,1.15-.013-7.911a.6.6,0,0,0-.276-.475l-6.924-3.983a.61.61,0,0,0-.529,0,.6.6,0,0,0-.062.036l-.024.015L197.678,77l-.026.012a.612.612,0,0,0-.1.058.594.594,0,0,0-.239.378.608.608,0,0,0-.009.07l.011,6.447,3.582-5.553a2.627,2.627,0,0,1,2.346-.961l1.071.028L198.006,87.6l.744.428,6.384-10.535,2.822-.01-6.368,10.8,2.654,1.526.317.182a.609.609,0,0,0,.427.008l7.022-4.069-1.342.778Zm.544,7.841-2.68-4.206,1.636-2.776,3.52,5.548Z",
    transform: "translate(-196.11 -71.799)",
    fill: "#2d374b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M321.883,217.849l2.68,4.206,2.476-1.435-3.52-5.548Z",
    transform: "translate(-313.176 -205.312)",
    fill: "#28a0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M362.578,167.824l0-1.15-3.846-5.99-1.427,2.421,3.713,6,1.342-.778a.6.6,0,0,0,.22-.433Z",
    transform: "translate(-346.461 -154.203)",
    fill: "#28a0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M177.491,155.982l1.9,1.092,6.309-10.117-1.071-.028a2.627,2.627,0,0,0-2.346.961l-3.582,5.553-1.205,1.852v.688Z",
    transform: "translate(-177.491 -141.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M230.472,147.406l-2.822.01-6.384,10.535,2.231,1.285.607-1.029Z",
    transform: "translate(-218.626 -141.725)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M194.8,58.86a1.8,1.8,0,0,0-.844-1.445l-7.015-4.034a1.825,1.825,0,0,0-1.61,0c-.059.03-6.822,3.952-6.822,3.952a1.795,1.795,0,0,0-1.016,1.524v8.355l1.205-1.852-.011-6.447a.6.6,0,0,1,.248-.448c.032-.023,6.911-4,6.933-4.016a.61.61,0,0,1,.529,0l6.924,3.983a.6.6,0,0,1,.276.475V66.89a.582.582,0,0,1-.207.433l-1.342.778-.693.4-2.476,1.435-2.511,1.455a.609.609,0,0,1-.427-.008l-2.971-1.709-.607,1.029,2.67,1.537.231.131c.1.056.168.094.192.105a1.734,1.734,0,0,0,.709.146,1.785,1.785,0,0,0,.654-.123l7.293-4.223a1.783,1.783,0,0,0,.687-1.343Z",
    transform: "translate(-177.492 -53.193)",
    fill: "#96bedc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbitrum);
export default __webpack_public_path__ + "static/media/arbitrum.0625f26458e224d0a99464dfd36a046c.svg";
export { ForwardRef as ReactComponent };